import * as React from "react";
import { Link } from "react-router-dom";
import { isEmpty, get } from 'lodash';
import { callApi } from "../../utils/api";
import { ADMIN_ROLE, MANAGER_ROLE } from "../../utils/role";
import SearchBox from "./SearchBox";
import Select from 'react-select';
import {
  ToastsStore,
  ToastsContainer,
  ToastsContainerPosition,
} from "react-toasts";
import { getFileStatus } from "../../utils/fileStatus";
import Cookies from "js-cookie";
import moment from "moment";
import TitleDeedInfo from "../work-file/TitleDeedInfo";

declare var $: any;
interface User {
  id: string;
  name: string;
  roleType: string;
  daily_quota_limit: string;
  quota_count: string;
}
interface AllProps {
  match: any;
  history: any;
}
class Header extends React.Component<AllProps> {
  state = {
    notifications: [],
    viewPolicy: false,
    bankList: [],
    bankId: '',
    bankPolicyList: [],
    policyList: [],
    selectedBankPolicyList: [],
    selectedBankDontPolicyList: [],
    isBankPolicyListLoaded: false,
    isBankListLoaded: false,
    isPolicyListLoaded: false,
    autoassign: false,
    pageDynamic: [],
    quotausers: [] as User[],
    users: [] as User[],
    fileNo: "",
    poName: "",
    voName: "",
    fileStatus: "",
    takenStatus: "",
    VtakenStatus: "",
    rectificationStatus: "",
    mailtobank: false,
    file_id: "",
    fileData: {
      assigned_to: "",
      verified_by: "",
      dverified_by: "",
      deviation_by: "",
      rectify_by: "",
      bank_name: "",
      bank_branch_name: "",
      lh_branch_name: "",
      file_status: '',
      rectify_status: '',
      property_ownername: '',
      borrower_name: '',
      emergent_file_grade: '',
      file_grade: '',
    },
    express: {
      file_id: "",
      express_type: "",
      express_option: "",
      assign_status: "",
      assign_to: "",
      express_reason: "",
      query_validation_type: "",
    },
    recover: {
      file_id: ""
    },
    fileDocCopy: {
      copyFrom_file_id: "",
      copyTo_file_id: "",
      actionType: "copy", // default action type
    },
    deedinfo: {
      loan_amount: "",
      contact_number: "",
      coApplicant: "",
      type_loan: "",
      appid: "",
      borrowername: "",
      bank_name: "",
      login_time: "",
      deedinfo: []
    },
    expressError: false,
    recoverError: false,
    isLoading: false,
    isRecoverLoading: false,
    files: [],
    reassignValidMessage: '',
    showValid: false,
    showFileStatusValid: false,
    fileStatusValidMsg: '',
    requestedShiftCount: 0
  };
  componentDidMount() {
    // this.getNotification();
    this.autoAssignGet();
    this.getPageDynamicData();
    this.getQuotaUsers();
    this.getUsers();
    this.listShiftExtensions();
    this.refreshEmergentQuota();
  }

  refreshEmergentQuota = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (!userId) return;

    callApi("POST", "emergent_quota_get.php", { userid: userId })
      .then((res) => res.data)
      .then((result) => {
        if (result?.statusCode === 200 && typeof result?.emergent_quota !== "undefined") {
          localStorage.setItem("emergent_quota", String(result.emergent_quota));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  listShiftExtensions = () => {
    const currentDate = moment();

    const payload = {
      user_id: '',
      status: 'pending',
      page: 1,
      limit: 100,
      from_dt: moment(currentDate, "DD.MM.YYYY"),
      to_dt: moment(currentDate, "DD.MM.YYYY"),
      path: "header"
    }
    callApi("POST", "get_shift_extension_requests.php", payload)
      .then(res => res.data)
      .then(response => {
        this.setState({
          requestedShiftCount: response?.data?.length || 0,
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          requestedShiftCount: 0
        });
      });

  };
  getQuotaUsers = () => {
    callApi("GET", "get_srm.php", "")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ quotausers: result?.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleQuotacount = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newQuotausers = [...this.state?.quotausers];
    newQuotausers[index][e.target.name] = e.target.value;
    this.setState({
      quotausers: newQuotausers
    });
  }
  updateQuotaCount = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const { quotausers } = this.state;
    const obj = {
      count: quotausers,
    };
    callApi("POST", "emergent_quota_update.php", obj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode == 200) {
          ToastsStore.success(res.message);
          $('#sro-quota').modal('hide');
        } else {
          ToastsStore.success("Not Updated");
        }
      });
  };
  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res?.data)
      .then((result) => {
        const pageDynamicData = result?.responseJson?.data;
        this.setState({
          pageDynamic: Array.isArray(pageDynamicData) ? pageDynamicData : [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  openViewPolicy = () => {
    this.getBankPolicyList();
    this.getPolicyList();
    this.setState({ viewPolicy: true })
  }
  closeViewPolicy = () => {
    this.setState({ viewPolicy: false, bankId: '', selectedBankPolicyList: [], selectedBankDontPolicyList: [] })
  }
  getPolicyDetailsById = (bankPolicy, key) => {
    let bankPolicyList = []
    const policyIds = get(bankPolicy, key, []).filter(id => id && id)
    if (!isEmpty(policyIds)) {
      bankPolicyList = policyIds.map(policyId => {
        return this.state.policyList.find((policy: any) => policy.policy_id === policyId)
      })
      bankPolicyList = bankPolicyList.filter(policyList => policyList && policyList)
    }
    return bankPolicyList
  }
  getNotification = () => {
    const user: any = localStorage.getItem("user");
    const id = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "notify_get.php", { id })
      .then(res => res.data)
      .then(response => {
        this.setState({ notifications: response.data });
      });
  };
  readNotification = modal => {
    callApi("POST", "notify_update.php", { notify_id: modal.notify_id })
      .then(res => res.data)
      .then(response => {
        this.getNotification();
      });
  };
  getBankPolicyList = () => {
    callApi("GET", "bank_policy_get.php")
      .then(res => res.data)
      .then(response => {
        let bankPolicyList = response.data;
        bankPolicyList = bankPolicyList.map((list, index) => {
          return { ...list, index: index + 1 }
        })
        this.setState({ bankPolicyList, isBankPolicyListLoaded: true });
        const bankList = bankPolicyList && bankPolicyList.map((option) => {
          return { label: option.bank_product_name, value: option.id }
        })
        this.setState({ bankList, isBankListLoaded: true });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getPolicyList = () => {
    callApi("GET", "policy_get.php")
      .then(res => res.data)
      .then(response => {
        let policyList = response.data;
        policyList = policyList.map((list, index) => {
          const { policy } = list;
          return { policy, index, policy_id: list.id }
        })
        this.setState({ policyList, isPolicyListLoaded: true });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getDeviceId = () => {
    let deviceId = Cookies.get("deviceId");
    return deviceId;
  };

  // Function to get the user's current location
  getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              long: position.coords.longitude,
            });
          },
          (error) => {
            console.error("Error getting location:", error);
            reject(error);
          }
        );
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  logout = async () => {
    const deviceId = this.getDeviceId();
    let location: any = {};

    try {
      // Get the user's location
      location = await this.getLocation();
    } catch (error) {
      // Handle case where location is not available
      console.warn("Proceeding without location data.");
    }

    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const payload = {
      userId,
      deviceId,
      ...location,
    };
    callApi("POST", "logout.php", payload)
      .then(res => res.data)
      .then(response => {
        if (response && response.status === 200) {
          localStorage.clear();
          window.location.href = "/login";
        }
      })
      .catch(err => {
        console.log(err);
        // this.setState({ isloading: false });
      });
  };
  policyTable = (policyList) => {
    return <table className="policy-table-header" id="rft-table-id">
      <thead>
        <tr className="table-header">
          <th>S.No</th>
          <th>Policy Name</th>
        </tr>
      </thead>
      <tbody>
        {policyList.map((list: any, index: any) => {
          return <tr key={index} className={`table-row${(index + 1) % 2 === 0 ? ' even-row' : ''}`}>
            <td>{index + 1}</td>
            <td>{list.policy}</td>
          </tr>
        })}
      </tbody>
    </table>
  }
  handleBankChange = e => {
    this.setState({ bankId: e.value, selectedBankPolicyList: [], selectedBankDontPolicyList: [] })
    if (this.state.isBankPolicyListLoaded && this.state.isBankListLoaded && this.state.isPolicyListLoaded) {
      const selectedBankPolicy = this.state.bankPolicyList.find((bankPolicy: any) => bankPolicy.id === e.value)
      if (!isEmpty(selectedBankPolicy)) {
        const selectedBankPolicyList = this.getPolicyDetailsById(selectedBankPolicy, 'policy');
        const selectedBankDontPolicyList = this.getPolicyDetailsById(selectedBankPolicy, 'dont_policy_id');
        this.setState({ selectedBankPolicyList, selectedBankDontPolicyList });
      }
    }
  }
  autoAssignGet = () => {
    callApi("GET", "module_option_select.php", "")
      .then((res) => res.data)
      .then((result) => {
        const autoAssignData = result.responseJson.data.find(
          (data) => data.module_name === "Auto Assign"
        );
        const mailtobanknData = result.responseJson.data.find(
          (data) => data.module_name === "Mail To Bank"
        );

        if (autoAssignData || mailtobanknData) {
          const autoassign = autoAssignData.status;
          const mailtobank = mailtobanknData.status;
          this.setState({ autoassign, mailtobank }, () => {
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  mailToBankUpdate(e) {
    let checkstatus = e.target.checked;
    if (checkstatus == true) {
      this.setState({ mailtobank: true });
    } else {
      this.setState({ mailtobank: false });
    }
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";
    let res = {
      module_name: "Mail To Bank",
      status: checkstatus == true ? 1 : 0,
      user_id: user_Id,
    };
    callApi("POST", "mailtobank_update.php", res)
      .then((res) => res.data)
      .then((response) => {
        if (response["statusCode"] === 200) {
          if (checkstatus == true) {
            ToastsStore.success("Enabled");
            localStorage.setItem("mail-bank", JSON.stringify(true));
          } else {
            ToastsStore.success("Disabled");
            localStorage.setItem("mail-bank", JSON.stringify(false));
          }
        } else {
          ToastsStore.error(response.message);
        }
      });
  }
  autoassignupdate(e) {
    let checkstatus = e.target.checked;
    if (checkstatus == true) {
      this.setState({ autoassign: true });
    } else {
      this.setState({ autoassign: false });
    }
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";
    let res = {
      module_name: "Auto Assign",
      status: checkstatus == true ? 1 : 0,
      user_id: user_Id
    }
    callApi("POST", "autoassign_update.php", res)
      .then(res => res.data)
      .then(response => {
        if (response["statusCode"] === 200) {
          if (checkstatus == true) {
            window.location.reload();
            ToastsStore.success("Auto Assign Enabled");
          } else {
            window.location.reload();
            ToastsStore.success("Auto Assign Disabled");
          }
        } else {
          ToastsStore.success(response.message);
        }

      });
  }
  getUsers = () => {
    callApi("GET", "user_get.php")
      .then(res => res.data)
      .then(response => {
        const usersData = response?.data;
        this.setState({ users: Array.isArray(usersData) ? usersData : [] });
      })
      .catch(err => {
        console.log(err);
      });
  };
  handleFileNoChange = (event) => {
    this.setState({
      fileNo: event.target.value, showFileStatusValid: false,
      fileStatusValidMsg: ''
    });
  };

  handlePONameChange = (event) => {
    this.setState({ poName: event.target.value });
  };

  handleVONameChange = (event) => {
    this.setState({ voName: event.target.value });
  };

  handleFileStatusChange = (event) => {
    this.setState({ fileStatus: event.target.value });
  };

  handleTakenStatusChange = (event) => {
    this.setState({ takenStatus: event.target.value });
  };

  handleVTakenStatusChange = (event) => {
    this.setState({ VtakenStatus: event.target.value });
  };
  handlerectificationStatus = (event) => {
    this.setState({ rectificationStatus: event.target.value });
  };

  changeStatus = () => {
    if (this.state.fileNo != "") {
      let req = {
        file_no: this.state.fileNo,
        po_name: this.state.poName,
        vo_name: this.state.voName,
        file_status: this.state.fileStatus,
        taken_status: this.state.takenStatus,
        v_taken_status: this.state.VtakenStatus,
        rectification_status: this.state.rectificationStatus
      }
      callApi("POST", "assign_files.php", req)
        .then((response) => response.data)
        .then((res) => {
          this.setState({
            fileNo: '',
            poName: '',
            voName: '',
            fileStatus: '',
            takenStatus: '',
            VtakenStatus: '',
            rectificationStatus: '',
          });
          if (res.status == 200) {
            ToastsStore.success(res.message);
            $('#file-status').modal('hide');
          } else {
            ToastsStore.error("Not Updated");
          }
        });
    } else {
      ToastsStore.error("File Number is must for change the file status");
    }
  }
  getdeedInfo = (fileid) => {
    callApi("POST", "get_title_deed_info.php", { id: fileid })
      .then(res => res.data)
      .then(result => {
        this.setState((prevState: any) => ({
          ...prevState,
          deedinfo: {
            ...prevState,
            loan_amount: result.loan_amount,
            contact_number: result.contact_number,
            coApplicant: result.coApplicant,
            type_loan: result.type_loan,
            appid: result.appid,
            borrowername: result.borrowername,
            bank_name: result.bank_name,
            login_time: result.login_time,
            deedinfo: result.data
          },
          reassignValidMessage: "",
          showValid: false
        }))
      })
      .catch(err => {
        console.log(err);
      });
  }

  getFiles = async (fileid, type) => {
    // await this.getRectifyFiles(fileid);
    if (isEmpty(fileid) || /^[\s-]/.test(fileid)) {
      this.setState({ fileData: [], files: [] });
      ToastsStore.error("Please enter valid file number");
      return;
    }
    callApi("POST", "search.php", {
      file_name: fileid
    })
      .then(res => res.data)
      .then(response => {
        if (response.data && response?.data?.length > 0) {
          this.setState({
            //express modal
            express: {
              file_id: fileid,
              express_option: '',
              express_type: '',
              assign_status: '',
              assign_to: '',
              express_reason: '',
              query_validation_type: '',
            },
            expressError: false,
            showValid: false,
            reassignValidMessage: '',
            //file status modal
            showFileStatusValid: false,
            fileStatusValidMsg: '',
            fileNo: fileid,
            poName: '',
            voName: '',
            fileStatus: '',
            takenStatus: '',
            VtakenStatus: '',
            rectificationStatus: '',
          });
          if (type != 'fileDocCopy') {
            if (response['data'] && response['data'][0]) {
              const filestatus = response['data'][0].file_status;
              const files = response.data;
              if (filestatus == "5") {
                this.setState({ reassignValidMessage: "Completed file can't be processed", showValid: true, filestatus, fileData: response['data'][0], files, showFileStatusValid: false, fileStatusValidMsg: '' });
                return;
              }
              this.setState({ filestatus, fileData: response['data'][0], files, reassignValidMessage: '', showValid: false, showFileStatusValid: false, fileStatusValidMsg: '' });
            } else {
              const current_file_status = response.file_status;
              if (current_file_status == "-1") {
                this.setState({ fileData: [], showValid: true, showFileStatusValid: true, reassignValidMessage: "This file is in New Login. So can't be processed", fileStatusValidMsg: "This file is in New Login. So can't be processed", files: [] });
                return;
              }
              if (this.state.express.file_id == "") {
                this.setState({ fileData: [], showValid: false, reassignValidMessage: '', files: [] });
              } else {
                this.setState({ fileData: [], showValid: true, showFileStatusValid: true, reassignValidMessage: '', files: [] });
                ToastsStore.error("No data found.");
              }
            }
          } else {
            this.getdeedInfo(fileid);
            this.setState({ fileData: response['data'][0] });
          }
        } else {
          this.setState({
            isLoading: false,
            fileData: [],
            deedinfo: { deedinfo: [], loan_amount: '', contact_number: '', coApplicant: '', type_loan: '', appid: '', borrowername: '', bank_name: '', login_time: '' },
          });
          ToastsStore.error("No data found. Kindly Recovery the flie");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleExpressChange = (e) => {
    const { name, value } = e.target;
    if (name == "file_id") {
      this.setState({ fileData: [], showValid: false, reassignValidMessage: '' });
    }
    this.setState((prevState: any) => ({
      ...prevState,
      express: {
        ...prevState.express,
        [name]: value
      },
      reassignValidMessage: ""
    }), () => {
      const updatedExpress = {
        ...this.state.express,
        [name]: value
      };
      if (this.state.files.length > 0) {
        this.state.files.forEach((file: any) => {
          let { file_status, assigned_to, process_office_id, verification_office_id, dverification_office_id, d_taken_ids, deviation_office_id, rectify_office_id, deviation_status, file_grade, double_verify_status } = file;

          const grade_list = ['A+', 'A1', 'A', 'B', 'C'];
          const rectification_grade_list = ['A', 'B', 'C'];
          const assign_to = updatedExpress.assign_to;

          // // Ensure `this.state.users` exists and contains the `assign_to` user
          const user: any = this.state?.users?.find((emp: any) => emp.id == assign_to);


          // if (updatedExpress.express_option == "Deviation" && assign_to) {
          //   const userGrade = user?.d_grade;
          //   if (userGrade != "D") {
          //     this.setState({
          //       reassignValidMessage: `This file cannot be processed because the Deviation grade is not selected to the selected User.`,
          //       showValid: true,
          //     });
          //     return;
          //   }
          // } else if (updatedExpress.express_option == "Rectification" && assign_to) {
          //   const userGrade = user?.r_grade;
          //   if (isEmpty(userGrade)) {
          //     this.setState({
          //       reassignValidMessage: `This file cannot be processed because the Rectification grade is not selected to the selected User.`,
          //       showValid: true,
          //     });
          //     return;
          //   }
          // }

          if (user && user.user_grade && file_grade && updatedExpress.express_option == "Process") {
            // const userGrade = updatedExpress.express_option == "Rectification" ? user?.rectify_user_grade : user.user_grade;
            // const fileGrade = updatedExpress.express_option == "Rectification" ? rectify_file_grade : file_grade;
            // const userGradeIndex = updatedExpress.express_option == "Rectification" ? rectification_grade_list.indexOf(userGrade) : grade_list.indexOf(userGrade);
            // const fileGradeIndex = updatedExpress.express_option == "Rectification" ? rectification_grade_list.indexOf(rectify_file_grade) : grade_list.indexOf(file_grade);
            const userGrade = user.user_grade;
            const fileGrade = file_grade;
            const userGradeIndex = grade_list.indexOf(userGrade);
            const fileGradeIndex = grade_list.indexOf(file_grade);

            // if (userGradeIndex === -1) {
            //   console.error(`Invalid user grade: ${userGrade}`);
            // }

            // if (fileGradeIndex === -1) {
            //   console.error(`Invalid file grade: ${fileGrade}`);
            // }

            // Dynamically generate error message for grade mismatch
            if (userGradeIndex > -1 && fileGradeIndex > -1 && userGradeIndex > fileGradeIndex) {
              this.setState({
                reassignValidMessage: `This file cannot be processed because the user grade (${userGrade}) is lower than the file grade (${fileGrade}).`,
                showValid: true,
              });
              return;
            }
          }
          // else if (updatedExpress.express_option == "Verification" && assign_to) {
          //   const userGrade = user?.v_grade;
          //   if (isEmpty(userGrade)) {
          //     this.setState({
          //       reassignValidMessage: `This file cannot be processed because the Verification grade is not selected to the selected User.`,
          //       showValid: true,
          //     });
          //     return;
          //   }
          // }

          if (file_status == "5" && double_verify_status == "0") {
            this.setState({ reassignValidMessage: "Completed file can't be processed", showValid: true });
            return;
          } else if (file_status == "9" && (updatedExpress.express_option == 'Process' || updatedExpress.express_option == "Verification")) {
            this.setState({ reassignValidMessage: "This file is in to be Rectification. So can't be processed", showValid: true });
            return;
          } else if (file_status == "7") {
            this.setState({ reassignValidMessage: "This file is still not query received. So can't be processed", showValid: true });
            return;
          } else if (file_status == "3") {
            this.setState({ reassignValidMessage: "This file is in Hold. So can't be processed", showValid: true });
            return;
          } else if ((file_status == "6" || file_status == '14') && updatedExpress.express_option == 'Process') {
            this.setState({ reassignValidMessage: "This file is can't be processed for Process", showValid: true });
            return;
          } else if ((file_status == '12' || file_status == '13') && updatedExpress.express_option != "DoubleVerification") {
            this.setState({ reassignValidMessage: "This file is in Double Verification Process. So can't be processed for other than Double Verification", showValid: true });
            return;
          } else if (file_status != "6" && file_status != "14" && updatedExpress.express_option == "Verification") {
            this.setState({ reassignValidMessage: "This file is in Process. So can't be processed for Verification", showValid: true });
            return;
          } else if (double_verify_status == "0" && updatedExpress.express_option == "DoubleVerification") {
            this.setState({ reassignValidMessage: "This file cannot be processed. Because file is not initiated to DV", showValid: true });
            return;
          } else if (updatedExpress.express_option == "Process") {
            if (updatedExpress.express_type == "Reassign" && isEmpty(assigned_to)) {
              this.setState({ reassignValidMessage: "This file cannot be Reassign since it don't have an PO.", showValid: true });
              return;
            }
            // if (!isEmpty(updatedExpress.assign_to) && process_office_id == updatedExpress.assign_to && updatedExpress.assign_status != "Assign in Queue") {
            //   this.setState({ reassignValidMessage: "This file cannot be processed. Because already Process Officer for this file", showValid: true });
            //   return;
            // }
          } else if (updatedExpress.express_option == "Verification") {
            if (updatedExpress.express_type == "Reassign" && isEmpty(verification_office_id)) {
              this.setState({ reassignValidMessage: "This file cannot be Reassign since it don't have an VO.", showValid: true });
              return;
            }
            // if (!isEmpty(updatedExpress.assign_to) && verification_office_id == updatedExpress.assign_to) {
            //   this.setState({ reassignValidMessage: "This file cannot be processed. Because already Verification Officer for this file", showValid: true });
            //   return;
            // }
            if (updatedExpress.express_type == "Assign") {
              if (process_office_id == updatedExpress.assign_to) {
                this.setState({ reassignValidMessage: "This file cannot be assign. Because this user worked as PO for this file.", showValid: true });
                return;
              }
            }
          } else if (updatedExpress.express_option == "DoubleVerification") {
            if (updatedExpress.express_type == "Reassign" && isEmpty(dverification_office_id)) {
              this.setState({ reassignValidMessage: "This file cannot be Reassign since it don't have an DVO.", showValid: true });
              return;
            }
            // if (!isEmpty(updatedExpress.assign_to) && verification_office_id == updatedExpress.assign_to) {
            //   this.setState({ reassignValidMessage: "This file cannot be processed. Because already Verification Officer for this file", showValid: true });
            //   return;
            // }
            if (updatedExpress.express_type == "Assign") {
              if ((process_office_id == updatedExpress.assign_to) && (verification_office_id == updatedExpress.assign_to)) {
                this.setState({ reassignValidMessage: "This file cannot be assign. Because this user worked as PO or VO for this file.", showValid: true });
                return;
              }
            }
          } else if (updatedExpress.express_option == "Deviation") {
            if (deviation_status == 0) {
              this.setState({ reassignValidMessage: "This file cannot be processed. Because file is not in Deviation Status", showValid: true });
              return;
            }
            if (!isEmpty(updatedExpress.assign_to) && process_office_id == updatedExpress.assign_to) {
              this.setState({ reassignValidMessage: "This file cannot be processed. Because already Process officer for this file", showValid: true });
              return;
            }
            // if (!isEmpty(updatedExpress.assign_to) && deviation_office_id == updatedExpress.assign_to) {
            //   this.setState({ reassignValidMessage: "This file cannot be processed. Because already Deviation officer for this file", showValid: true });
            //   return;
            // }
            if (!isEmpty(d_taken_ids) && d_taken_ids.split(',').map(id => id.trim()).includes(String(updatedExpress.assign_to))) {
              this.setState({ reassignValidMessage: "This file cannot be processed. Because already worked for Deviation", showValid: true });
              return;
            }
            if (updatedExpress.express_type == "Reassign" && isEmpty(deviation_office_id)) {
              this.setState({ reassignValidMessage: "This file cannot be Reassign since it don't have an DO.", showValid: true });
              return;
            }
          } else if (updatedExpress.express_option == "Rectification") {
            if (file_status != "9") {
              this.setState({ reassignValidMessage: "This file cannot be processed. Because file is not in Rectification Status", showValid: true });
              return;
            }
            if (updatedExpress.express_type == "Reassign" && isEmpty(rectify_office_id)) {
              this.setState({ reassignValidMessage: "This file cannot be Reassign since it don't have an RO.", showValid: true });
              return;
            }
            // if (rectify_office_id == updatedExpress.assign_to) {
            //   this.setState({ reassignValidMessage: "This file cannot be processed. Because already Rectification officer for this file", showValid: true });
            //   return;
            // }
          }
          this.setState({ showValid: false, reassignValidMessage: '', expressError: false });
        });
      }
    });
  }

  submitExpress = () => {
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";

    if (isEmpty(this.state.express.file_id) || isEmpty(this.state.express.express_type) ||
      isEmpty(this.state.express.express_option) || isEmpty(this.state.express.assign_status) || isEmpty(this.state.express.express_reason)) {
      this.setState({ expressError: true });
      return;
    } else if (this.state.express.express_option == "QueryValidation" &&
      isEmpty(this.state.express.query_validation_type)) {
      this.setState({ expressError: true });
      return;
    } else if (isEmpty(this.state.express.assign_to) &&
      this.state.express.assign_status != "Assign in Queue") {
      this.setState({ expressError: true });
      return;
    } else {
      this.setState({ expressError: false, isLoading: true });

      const request = {
        "file_id": this.state.express.file_id,
        "express_type": this.state.express.express_type,
        "express_option": this.state.express.express_option,
        "assign_status": this.state.express.assign_status,
        "assign_to": this.state.express.assign_to,
        "express_reason": this.state.express.express_reason,
        "query_validation_type": this.state.express.query_validation_type,
        "user_id": user_Id
      }

      callApi("POST", "express_create.php", request)
        .then(res => res.data)
        .then(response => {
          if (response.status == 200) {
            // Clear ALL fields - modal stays open
            this.setState({
              isLoading: false,
              express: {
                file_id: '',           // Clear file number
                express_type: '',
                express_option: '',
                assign_status: '',
                assign_to: '',
                express_reason: '',
                query_validation_type: '',
              },
              fileData: {              // Reset to empty object, not array
                assigned_to: "",
                verified_by: "",
                dverified_by: "",
                deviation_by: "",
                rectify_by: "",
                bank_name: "",
                bank_branch_name: "",
                lh_branch_name: "",
                file_status: '',
                property_ownername: '',
                borrower_name: ''
              },
              files: [],                // Clear files array
              expressError: false,
              showValid: false,
              reassignValidMessage: ''
            });
            ToastsStore.success(response.message);
          } else {
            ToastsStore.error(response.message);
            this.setState({ isLoading: false });
          }
        }).catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    }
  }
  handlerecoverchange = (e) => {
    const { name, value } = e.target;
    const { recover } = this.state;

    this.setState((prevState: any) => ({
      ...prevState,
      recover: {
        ...prevState.recover,
        [name]: value
      },
      reassignValidMessage: "",
      showValid: false
    }), () => {
      const updatedrecover = {
        ...this.state.recover,
        [name]: value
      }


    })

  }

  findrecover = () => {
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";
    if (isEmpty(this.state.recover.file_id)) {
      this.setState({ recoverError: true });
      return;
    } else {
      this.setState({ recoverError: false });
      const request = {
        "file_name": this.state.recover.file_id
      }

      callApi("POST", "find_file_recover.php", request)
        .then(res => res.data)
        .then(response => {
          if (response.statusCode == 200) {
            this.setState({ reassignValidMessage: response.message, showValid: true });
          } else {
            this.setState({ reassignValidMessage: response.message, showValid: true });
          }
        })
    }

  }
  filerecover = () => {
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";
    if (isEmpty(this.state.recover.file_id)) {
      this.setState({ recoverError: true });
      return;
    } else {
      this.setState({ recoverError: false, isRecoverLoading: true });
      const request = {
        "file_name": this.state.recover.file_id
      }
      callApi("POST", "recover_backup_api/file_recover_from_server.php", request)
        .then(res => res.data)
        .then(response => {
          if (response.statusCode == 200) {
            this.setState({ reassignValidMessage: '', showValid: true, isRecoverLoading: false });
            $("#file-recover").modal("hide");
            this.setState({
              recover: {
                file_id: ''
              }
            });
            ToastsStore.success(response.message);
          }
          else {
            this.setState({ reassignValidMessage: response.message, showValid: true, isRecoverLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isRecoverLoading: false });
        })

    }
  }

  handleFileDocAction = (action: "copy" | "delete") => {
    const { copyFrom_file_id, copyTo_file_id } = this.state.fileDocCopy;
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";

    if (isEmpty(copyFrom_file_id) || isEmpty(copyTo_file_id)) {
      ToastsStore.error('Please enter valid file numbers');
      return;
    }

    this.setState({ isLoading: true });

    const request =
      action === "copy"
        ? { copyFrom: copyFrom_file_id, copyTo: copyTo_file_id, "user_id": user_Id }
        : { deleteFrom: copyFrom_file_id, deleteTo: copyTo_file_id, "user_id": user_Id };

    const apiEndpoint =
      action === "copy" ? "file_doc_copy.php" : "file_doc_copy_delete.php";

    callApi("POST", apiEndpoint, request)
      .then((res) => res.data)
      .then((response) => {
        if (response.statusCode === 200) {
          this.setState({
            isLoading: false,
            fileData: [],
            deedinfo: { deedinfo: [], loan_amount: '', contact_number: '', coApplicant: '', type_loan: '', appid: '', borrowername: '' },
            fileDocCopy: { copyFrom_file_id: "", copyTo_file_id: "", actionType: "copy" },
          });
          $("#file-doc-copy").modal("hide");
          ToastsStore.success(response.message);
        } else {
          ToastsStore.error(response.message);
          this.setState({ isLoading: false });
        }
      });
  };

  clearFields = () => {
    this.setState({
      //express modal
      express: {
        file_id: '',
        express_option: '',
        express_type: '',
        assign_status: '',
        assign_to: '',
        express_reason: '',
        query_validation_type: '',
      },
      expressError: false,
      showValid: false,
      reassignValidMessage: '',
      //file status modal
      showFileStatusValid: false,
      fileStatusValidMsg: '',
      fileNo: '',
      poName: '',
      voName: '',
      fileStatus: '',
      takenStatus: '',
      VtakenStatus: '',
      rectificationStatus: '',
    });
  };

  handleActionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState((prev: any) => ({
      ...prev,
      fileDocCopy: {
        ...prev.fileDocCopy,
        actionType: value,
      },
    }));
  };

  render() {
    const user: any = localStorage.getItem("user");
    const user_Id = user ? JSON.parse(user)["userId"] : "";
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const userName = user ? JSON.parse(user)["userName"] : "";
    const { quotausers } = this.state;
    const pageDynamicList = Array.isArray(this.state.pageDynamic) ? this.state.pageDynamic : [];
    const usersList = Array.isArray(this.state.users) ? this.state.users : [];
    // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
    const isAdminAccess = pageDynamicList.find((page: any) => page.page_name === "Shift List" && page.status == true);
    const isExpressAccess = pageDynamicList.find((page: any) => page.page_name === "Express Option" && page.status == true);

    return (
      <>
        <header className="navbar pcoded-header navbar-expand-lg navbar-light headerpos-fixed">
          <ToastsContainer
            store={ToastsStore}
            position={ToastsContainerPosition.TOP_RIGHT}
          />
          <div className="m-header">
            <a href="index.html" className="b-brand">
              <div className="b-bg">L</div>
              <span className="b-title">Law Hands</span>
            </a>
          </div>
          <SearchBox {...this.props} />
          <div className="collapse navbar-collapse navbar-mobile">
            <ul className="navbar-nav mr-auto">
              <li>
                <div className="page-header" />
              </li>
            </ul>

            <ul className="navbar-nav ml-auto">
              <li className="nav-item align-middle">
                <button className="btn btn-outline-primary mr-3" style={{
                  margin: "auto", padding: "3px 5px"
                }} onClick={() => this.openViewPolicy()}>
                  Bank Policy
                </button>
                <Link to={{
                  pathname: "/file/add/0",
                }} onClick={() => {
                  localStorage.setItem("LoginFile", "true");
                }} className="btn btn-outline-secondary" style={{ fontWeight: "bold", borderWidth: "2px", padding: "3px 5px" }}>Add File</Link>
                <Link to={"/rectifyfile/add/0"} className="btn btn-outline-dark" style={{ fontWeight: "bold", borderWidth: "2px", padding: "3px 5px" }}>Add Rectification</Link>
                <Link to={{
                  pathname: "/vetting-add/0",
                  state: { fromLoginFile: true },
                }} className="btn btn-outline-dark" style={{ fontWeight: "bold", borderWidth: "2px", padding: "3px 5px" }}>Add Vetting</Link>
              </li>

              <li className="nav-item">
                <div className="dropdown">
                  <Link to={"/all-Pushnotifications"}> <i style={{ fontSize: "18px" }} className="icon feather icon-bell"></i></Link >
                </div>
              </li>

              <li className="nav-item">
                <div className="dropdown drp-user">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                    <i className="icon feather fa fa-cog" />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right profile-notification" style={{ maxHeight: "500px", overflowY: "scroll" }}>
                    <ul className="pro-body">
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={this.logout}
                        >
                          <i className="feather icon-log-out" /> Logout
                        </a>
                      </li>
                      {(() => {
                        // 1. Predefined Order
                        const orderedPages = [
                          "User Management",
                          "Training Files Management",
                          "Role Management",
                          "Bank Management",
                          "Vetting Bank Management",
                          "Bank Branch Management",
                          "Branch Management",
                          "Deed Management",
                          "Template Management",
                          "Document Type Category Management",
                          "Original Present Management",
                          "Measure Label Management",
                          "SRO Management",
                          "Policy Management",
                          "Bank Policy Management",
                          "Q & A Management",
                          "Vetting Q & A Management",
                          "Add Video Category",
                          "Video Management",
                          "Block Download",
                          "Vetting Table Template Management",
                          "Authenticating Pages Management",
                          "File Grade Management",
                          "Employee Grade Management",
                          "Product Management",
                          "Bank + Product Management",
                          "Query Reason Management",
                          "Mode Management",
                          "Bank + Product + Branch Management",
                          "Feature Enable & Disable",
                          "Sample Format Management",
                          "Shift Management",
                          "Rectification Category Management",
                          "Vetting Category Management",
                          "Mistake Made By Management",
                          "Deviation Take Management",
                          "PDF Compression Management",
                          "Auto Mail Management",
                          "Vetting Auto Mail Management",
                          "Emergent Quota Count Management",
                          "Deviation Mail to Bank",
                          "Express",
                          "File Recover",
                          "File Document Copy Option",
                        ];

                        // 2. Links for normal pages
                        const pageLinks: { [key: string]: string } = {
                          "User Management": "/user",
                          "Training Files Management": "/manageFiles",
                          "Role Management": "/role",
                          "Bank Management": "/bank",
                          "Vetting Bank Management": "/vetting-bank",
                          "Bank Branch Management": "/bank-branch",
                          "Branch Management": "/branch",
                          "Deed Management": "/deed",
                          "Template Management": "/template",
                          "Original Present Management": "/original-present",
                          "Measure Label Management": "/measure",
                          "SRO Management": "/sro",
                          "Policy Management": "/manage-policy",
                          "Bank Policy Management": "/manage-bank-policy",
                          "Q & A Management": "/manage-qa",
                          "Vetting Q & A Management": "/vetting-manage-qa",
                          "Add Video Category": "/video-category",
                          "Video Management": "/manage-video",
                          "Block Download": "/block-download",
                          "Vetting Table Template Management": "/vetting-table-template",
                          "Authenticating Pages Management": "/authenticate-page",
                          "File Grade Management": "/bank-wise",
                          "Employee Grade Management": "/employee-wise",
                          "Product Management": "/product",
                          "Bank + Product Management": "/bank-product",
                          "Query Reason Management": "/query-reason",
                          "Mode Management": "/mode-management",
                          "Bank + Product + Branch Management": "/bank-product-branch",
                          "Feature Enable & Disable": "/features",
                          "Sample Format Management": "/bank-temp-manage",
                          "Shift Management": "/shift-details",
                          "Rectification Category Management": "/rectify-category-manage",
                          "Document Type Category Management": "/document-type-category-manage",
                          "Vetting Category Management": "/vetting-category-manage",
                          "Mistake Made By Management": "/mistake-made-by-management",
                          "Deviation Take Management": "/devation-take-manage",
                          "PDF Compression Management": "/pdfcomponent",
                          "Auto Mail Management": "/autoMailManage",
                          "Vetting Auto Mail Management": "/vettingautoMailManage",
                        };

                        // 3. Modal pages
                        const modalConfigs = [
                          { name: "Emergent Quota Count Management", target: "#sro-quota", marginLeft: "10px" },
                          { name: "Deviation Mail to Bank", target: "#mail-bank", marginLeft: "8px" },
                          // { name: "Express", target: "#express-option", marginLeft: "10px" },
                          // Only show Express for specific user IDs
                          ...(isExpressAccess ?
                            [{ name: "Express", target: "#express-option", marginLeft: "10px" }] :
                            []),
                          // { name: "Auto Assign Enable & Disable", target: "#auto-assign", marginLeft: "10px" },
                          { name: "File Recover", target: "#file-recover", marginLeft: "10px" },
                          { name: "File Document Copy Option", target: "#file-doc-copy", marginLeft: "10px" },
                        ];

                        // 4. Create a lookup for status from this.state.pageDynamic
                        const pageStatusMap = pageDynamicList.reduce((acc: any, page: any) => {
                          acc[page.page_name] = page.status;
                          return acc;
                        }, {});

                        // 5. Render in predefined order
                        return orderedPages.map((pageName) => {
                          const status = pageStatusMap[pageName];
                          if (!status) return null;

                          if (pageLinks[pageName]) {
                            return (
                              <li key={pageName}>
                                <Link to={pageLinks[pageName]} className="dropdown-item">
                                  <i className="feather icon-corner-right-down" /> {pageName}
                                </Link>
                              </li>
                            );
                          }

                          const modalConfig = modalConfigs.find(cfg => cfg.name === pageName);
                          if (modalConfig) {
                            return (
                              <li key={pageName}>
                                <p
                                  className="dropdown-item d-flex"
                                  data-toggle="modal"
                                  data-target={modalConfig.target}
                                >
                                  <i className="feather icon-corner-right-down" style={{ color: "gray" }} />
                                  <span
                                    style={{ marginLeft: modalConfig.marginLeft, color: "gray", cursor: "pointer" }}
                                  >
                                    {pageName}
                                  </span>
                                </p>
                              </li>
                            );
                          }

                          return null;
                        });
                      })()}
                      {/* <li>
                        <Link to={'/pdf-compress'} className="dropdown-item">
                          <i className="feather icon-corner-right-down" /> Pdf Compress
                        </Link>
                      </li> */}
                      {user_Id == 242 && (
                        <li>
                          <p className="dropdown-item d-flex" data-toggle="modal"
                            data-target="#file-status" style={{ margin: "2px 0 5px -3px" }}>
                            <i style={{ color: "gray" }} className="feather icon-corner-right-down" />
                            <span style={{ marginLeft: "10px", color: "gray", cursor: "pointer" }}>
                              File Status
                            </span>
                          </p>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </li>

              {isAdminAccess && this.state.requestedShiftCount > 0 && (
                <li className="nav-item">
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <Link to={"/shift-details"}>
                      <i className="icon feather icon-clock" style={{ fontSize: "16px" }}></i>
                    </Link>
                    {this.state.requestedShiftCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "-12px",
                          background: "red",
                          color: "white",
                          borderRadius: "50%",
                          padding: "2px 5px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          minWidth: "18px",
                          height: "18px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: "1",
                        }}
                      >
                        {this.state.requestedShiftCount}
                      </span>
                    )}
                  </div>
                </li>
              )}

              <li className="nav-item" style={{ lineHeight: "20px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <img
                    src="data:image/jpeg;base64,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"
                    className="img-radius"
                    alt="User-Profile-Image"
                    width={"70px"}
                    height={"70px"}
                  />
                  <div>
                    <p style={{ marginBottom: "5px", marginTop: "5px" }}><b>{userName}</b></p>
                    <span style={{ fontSize: "14px", color: "green" }}>{role_label}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          {
            this.state.viewPolicy && <div className={`modal${this.state.viewPolicy ? ' open' : ''}`} id="preview-document">
              <div className="modal-dialog modal-lg"
                style={{ maxWidth: "800px" }}
              >
                <div className="modal-content" style={{ height: "90vh" }}>
                  <div className="modal-header">
                    <h4 className="modal-title">Bank Policy</h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={() => this.closeViewPolicy()}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body" style={{ height: "90vh", overflowY: "scroll" }}>
                    <div className="view-policy">
                      <Select options={this.state.bankList} name="bank_id"
                        value={this.state.bankList.find((option: any) => option.value === this.state.bankId)}
                        onChange={e => this.handleBankChange(e)}
                      />
                    </div>
                    {this.state.selectedBankPolicyList && this.state.selectedBankPolicyList.length > 0 &&
                      <div className="table-wrapper">
                        <a className="b-brand"><div className="b-bg green"><i className="feather icon-check"></i></div> <span > Do's Policy List</span></a>
                        {this.policyTable(this.state.selectedBankPolicyList)}
                      </div>
                    }
                    {this.state.selectedBankDontPolicyList && this.state.selectedBankDontPolicyList.length > 0 &&
                      <div className="table-wrapper">
                        <a className="b-brand"><div className="b-bg red"><i className="feather icon-x"></i></div> <span > Don'ts Policy List</span></a>
                        {this.policyTable(this.state.selectedBankDontPolicyList)}
                      </div>
                    }
                    {this.state.bankId && this.state.selectedBankPolicyList.length === 0 && this.state.selectedBankDontPolicyList.length === 0 && <div>No Policy Found for the selected bank</div>}
                  </div>
                </div>
              </div>
            </div>
          }
        </header >
        <div
          className="modal"
          id="auto-assign"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title">Auto Assign Enable & Disable</h5> */}
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body d-flex" style={{ justifyContent: "center" }}>
                <h5 className="modal-title">Auto Assign Enable & Disable</h5>

                <label className="switch" style={{ marginLeft: "10%" }}>
                  <input type="checkbox" checked={this.state.autoassign} onChange={(e) => this.autoassignupdate(e)} />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          id="sro-quota"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title">Auto Assign Enable & Disable</h5> */}
                <h5 className="modal-title">Emergent Quota Count Management</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="sticky-table-container">
                  <table className="table">
                    <thead className="sticky-table-header">
                      <tr>
                        <th scope="col" className="text-center">S.No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Role Type</th>
                        <th scope="col">Quota Count</th>
                        <th scope="col">Daily Quota Limit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quotausers?.map((scr: any, index: any) => {
                        return (
                          <tr
                            className="pointer"
                            key={index}
                          >
                            <td className="indexInput" style={{ textAlign: "center" }}>
                              {index + 1}
                            </td>
                            <td
                              className="indexInput" style={{ textAlign: "center" }}
                            >
                              {scr.name}
                            </td>
                            <td
                              className="indexInput" style={{ textAlign: "center" }}
                            >
                              {scr.roleType}
                            </td>
                            <td
                              className="indexInput" style={{ textAlign: "center" }}
                            >
                              {scr.quota_count}
                            </td>
                            <td
                              className="indexInput" style={{ textAlign: "center" }}
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={scr.daily_quota_limit}
                                onChange={e => this.handleQuotacount(e, index)}
                                name="daily_quota_limit"
                              />
                            </td>
                          </tr>
                        );
                      }
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.updateQuotaCount}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-mobile-width"
          id="file-status"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-center">File Status</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.clearFields}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <label style={{ marginTop: "2%" }}>File Number</label>
                <div className="form-group document-content">
                  <input
                    name="file-no"
                    className="form-control document-form"
                    placeholder="File No."
                    value={this.state.fileNo}
                    onChange={this.handleFileNoChange}
                    onBlur={() => this.getFiles(this.state.fileNo, 'fileStatus')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        if (!isEmpty(this.state.fileNo)) {
                          this.getFiles(this.state.fileNo, 'fileStatus');
                        }
                      }
                    }}
                  />
                </div>
                {this.state.showFileStatusValid && !isEmpty(this.state.fileStatusValidMsg) && !isEmpty(this.state.fileNo) && (
                  <div style={{ color: "red", fontSize: "14px", marginBottom: "10px" }}>{this.state.fileStatusValidMsg}</div>
                )}
                <label style={{ marginTop: "2%" }}>PO Name</label>
                <select id="po-name" className="form-control" value={this.state.poName} onChange={this.handlePONameChange}>
                  <option value="">Select PO Name</option>
                  {this.state.users?.map(user => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </select>
                <label style={{ marginTop: "5%" }}>VO Name</label>
                <select id="vo-name" className="form-control" value={this.state.voName} onChange={this.handleVONameChange}>
                  <option value="">Select VO Name</option>
                  <option value="remove_vo">Remove VO Name</option>
                  {this.state.users?.map(user => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </select>
                <label style={{ marginTop: "5%" }}>File Status</label>
                <select id="file-status" className="form-control" value={this.state.fileStatus} onChange={this.handleFileStatusChange}>
                  <option value="">Select File Status</option>
                  <option value="-1">New login</option>
                  <option value="0">Unassigned</option>
                  <option value="1">Assigned</option>
                  <option value="2">In progress</option>
                  <option value="7">Query raised files</option>
                  <option value="8">Query received files</option>
                  <option value="5">Verification complete</option>
                  <option value="9">Rectification</option>
                  <option value="6">Typing complete</option>
                  <option value="3">Hold</option>
                </select>
                <label style={{ marginTop: "5%" }}>Taken Status</label>
                <select id="file-status" className="form-control" value={this.state.takenStatus} onChange={this.handleTakenStatusChange}>
                  <option value="">Select Taken Status</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                </select>
                <label style={{ marginTop: "5%" }}>Verification Taken Status</label>
                <select id="file-status" className="form-control" value={this.state.VtakenStatus} onChange={this.handleVTakenStatusChange}>
                  <option value="">Select Taken Status</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                </select>
                {this.state.fileStatus === '9' ? <><label style={{ marginTop: "5%" }}>Rectification Status</label>
                  <select id="file-status" className="form-control" value={this.state.rectificationStatus} onChange={this.handlerectificationStatus}>
                    <option value="">Select Status</option>
                    <option value="0">Created</option>
                    <option value="1">Inprogress</option>
                    <option value="2">Completed</option>
                    <option value="3">query raised</option>
                    <option value="4">query received</option>
                  </select>
                </> : ""}
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ marginTop: "5%", marginBottom: "5%" }}
                  onClick={this.changeStatus}
                  disabled={this.state.showFileStatusValid}
                >
                  Change Status
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-mobile-width"
          id="express-option"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" style={{ maxWidth: "800px" }} role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-center">Express</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.clearFields}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body express-modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <label style={{ marginTop: "2%" }}>File Number<span style={{ color: "red" }}>*</span></label>
                    <div className="form-group document-content">
                      <input
                        className={this.state.expressError && isEmpty(this.state.express.file_id) ? 'form-control is-invalid' : 'form-control'}
                        name="file_id"
                        // className="form-control document-form"
                        placeholder="File No."
                        value={this.state.express.file_id}
                        onChange={this.handleExpressChange}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (!isEmpty(this.state.express.file_id)) {
                              this.getFiles(this.state.express.file_id, 'express');
                            }
                          }
                        }}
                        onBlur={() => this.getFiles(this.state.express.file_id, 'express')}
                      />
                    </div>
                    {this.state.expressError && isEmpty(this.state.express.file_id) && (
                      <div className="invalid-feedback" style={{ display: "block" }}>*Required Field</div>
                    )}
                    {this.state.showValid && !isEmpty(this.state.reassignValidMessage) && !isEmpty(this.state.express.file_id) && (
                      <div style={{ color: "red", fontSize: "14px", marginBottom: "10px" }}>{this.state.reassignValidMessage}</div>
                    )}
                  </div>
                </div>
                {!isEmpty(this.state.express.file_id) && <>
                  <div className="row express-file-detatils" style={{ padding: "0px 15px" }}>
                    <div className="col-md-6">
                      <p><span>File Status :</span>{getFileStatus(this.state.fileData?.file_status)} {this.state.fileData?.file_status == "9" ? <span style={{ color: "green" }}> ({this.state.fileData?.rectify_status})</span> : ''}</p>
                      <p><span>Bank Name :</span> {this.state.fileData?.bank_name ?? "-"}</p>
                      <p><span>Bank Branch Name :</span> {this.state.fileData?.bank_branch_name ?? "-"}</p>
                      <p><span>LH Branch Name :</span> {this.state.fileData?.lh_branch_name ?? "-"}</p>
                      <p><span>File Grade :</span>
                        {this.state.fileData?.file_grade ?? "-"}
                        {(!isEmpty(this.state.fileData?.emergent_file_grade) && this.state.fileData?.emergent_file_grade == "E") &&
                          <span style={{ color: "red" }} className="ml-2"> ({this.state.fileData?.emergent_file_grade ? "Emergent" : "-"})</span>
                        }
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p><span>PO :</span> {this.state.fileData && <>{this.state.fileData?.assigned_to ?? "-"}</>}</p>
                      <p><span>VO :</span> {this.state.fileData && <>{this.state.fileData?.verified_by ?? "-"}</>}</p>
                      <p><span>DVO :</span> {this.state.fileData && <>{this.state.fileData?.dverified_by ?? "-"}</>}</p>
                      <p><span>DO :</span> {this.state.fileData && <>{this.state.fileData?.deviation_by ?? '-'}</>}</p>
                      <p><span>RO :</span> {this.state.fileData && <>{this.state.fileData?.rectify_by ?? "-"}</>}</p>
                    </div>
                  </div>
                </>}

                <div className="row">
                  <div className="col-md-6">
                    <label style={{ marginTop: "2%" }}>Express Option<span style={{ color: "red" }}>*</span></label>
                    <select name="express_option" className={this.state.expressError && isEmpty(this.state.express.express_option) ? 'form-control is-invalid' : 'form-control'} value={this.state.express.express_option} onChange={this.handleExpressChange}>
                      <option value="">Select Express Option</option>
                      <option value="Process">Process</option>
                      <option value="Verification">Verification</option>
                      <option value="DoubleVerification">Double Verification</option>
                      <option value="Deviation">Deviation</option>
                      <option value="Rectification">Rectification</option>
                      <option value="FinalApproval">Final Approval</option>
                      <option value="QueryValidation">Query Validation</option>
                    </select>
                    {this.state.expressError && isEmpty(this.state.express.express_option) && (
                      <div className="invalid-feedback">*Required Field</div>
                    )}
                  </div>
                  {this.state.express.express_option == "QueryValidation" && <>
                    <div className="col-md-6">
                      <label style={{ marginTop: "2%" }}>Query Validation Type<span style={{ color: "red" }}>*</span></label>
                      <select name="query_validation_type" className={this.state.expressError && isEmpty(this.state.express.query_validation_type) ? 'form-control is-invalid' : 'form-control'}
                        value={this.state.express.query_validation_type} onChange={this.handleExpressChange}>
                        <option value="">Select Validation File Type</option>
                        <option value="newFile">New-File</option>
                        <option value="queryFile">Query-File</option>
                        <option value="rectificationFile">Rectification-File</option>
                        {/* <option value="verificationFile">Verification-File</option> */}
                      </select>
                      {this.state.expressError && isEmpty(this.state.express.query_validation_type) && (
                        <div className="invalid-feedback">*Required Field</div>
                      )}
                    </div>
                  </>}
                  <div className="col-md-6">
                    <label style={{ marginTop: "2%" }}>Express Type<span style={{ color: "red" }}>*</span></label>
                    <select name="express_type" className={this.state.expressError && isEmpty(this.state.express.express_type) ? 'form-control is-invalid' : 'form-control'}
                      value={this.state.express.express_type} onChange={this.handleExpressChange}>
                      <option value="">Select Express Type</option>
                      <option value="Assign">Assign</option>
                      <option value="Reassign">Reassign</option>
                      <option value="Emergent">Emergent</option>
                    </select>
                    {this.state.expressError && isEmpty(this.state.express.express_type) && (
                      <div className="invalid-feedback">*Required Field</div>
                    )}
                  </div>
                  {/* </div>

                <div className="row"> */}
                  <div className="col-md-6">
                    <label style={{ marginTop: "5%" }}>Assign Status<span style={{ color: "red" }}>*</span></label>
                    <select name="assign_status" className={this.state.expressError && isEmpty(this.state.express.assign_status) ? 'form-control is-invalid' : 'form-control'} value={this.state.express.assign_status} onChange={this.handleExpressChange}>
                      <option value="">Select Assign Status</option>
                      {this.state.express.express_type != "Assign" && <>
                        <option value="Assign in Queue">Assign in Queue</option>
                      </>}
                      <option value="Direct Assign Queue">Direct Assign - (QUEUE)</option>
                      <option value="Direct Assign Next">Direct Assign - (NEXT)</option>
                    </select>
                    {this.state.expressError && isEmpty(this.state.express.assign_status) && (
                      <div className="invalid-feedback">*Required Field</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.state.express.assign_status != "Assign in Queue" && <>
                      <label style={{ marginTop: "5%" }}>Assign To<span style={{ color: "red" }}>*</span></label>
                      <Select
                        name="assign_to"
                        options={usersList.map((user: any) => ({
                          value: user.id,
                          label: ` ${user?.name}(${user?.user_grade})`
                        }))}
                        value={
                          this.state.express.assign_to
                            ? { value: this.state.express.assign_to, label: usersList.find(u => u.id === this.state.express.assign_to)?.name || '' }
                            : null
                        }
                        onChange={(selected) => this.handleExpressChange({
                          target: { name: 'assign_to', value: selected?.value || '' }
                        })}
                        placeholder="Select Assign To"
                        isSearchable={true}
                        className={this.state.expressError && !this.state.express.assign_to ? 'is-invalid' : ''}
                      />
                      {this.state.expressError && isEmpty(this.state.express.assign_to) && (
                        <div className="invalid-feedback">*Required Field</div>
                      )}
                    </>}
                  </div>
                  {/* </div>

                <div className="row"> */}
                  <div className="col-md-12">
                    <label style={{ marginTop: "2%" }}>Reason<span style={{ color: "red" }}>*</span></label>
                    <textarea
                      className={this.state.expressError && isEmpty(this.state.express.express_reason) ? 'form-control is-invalid' : 'form-control'}
                      name="express_reason"
                      value={this.state.express.express_reason}
                      onChange={this.handleExpressChange}
                    />
                    {this.state.expressError && isEmpty(this.state.express.express_reason) && (
                      <div className="invalid-feedback">*Required Field</div>
                    )}
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ marginTop: "5%", marginRight: "10px", float: "left" }}
                  onClick={this.clearFields}
                >
                  Clear
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ marginTop: "5%", float: "right" }}
                  onClick={this.submitExpress}
                  disabled={this.state.showValid || this.state.expressError}
                >
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="file-doc-copy"
          role="dialog"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ maxWidth: "1000px" }}
          >
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">File Document {this.state.fileDocCopy.actionType == 'copy' ? "Copy" : 'Delete Copy'}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState({
                      isLoading: false,
                      fileData: [],
                      deedinfo: { deedinfo: [], loan_amount: '', contact_number: '', coApplicant: '', type_loan: '', appid: '', borrowername: '', bank_name: '', login_time: '' },
                      fileDocCopy: { copyFrom_file_id: "", copyTo_file_id: "", actionType: "copy" },
                    });
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "20px",
                  borderRadius: "8px",
                  maxHeight: "570px",
                  overflowY: "auto",
                }}
              >
                <form>
                  {/* Action Selector */}
                  <div className="form-row mb-3">
                    <div className="col-md-12">
                      <label>
                        <strong>Select Action:</strong>
                      </label>
                      <div className="form-check form-check-inline" style={{ marginLeft: "10px", gap: "5px" }}>
                        <input
                          type="radio"
                          name="actionType"
                          value="copy"
                          checked={this.state.fileDocCopy.actionType === "copy"}
                          onChange={this.handleActionChange}
                        />
                        <label className="form-check-label" htmlFor="actionCopy">
                          Copy
                        </label>
                      </div>

                      <div className="form-check form-check-inline" style={{ marginLeft: "10px", gap: "5px" }}>
                        <input
                          type="radio"
                          name="actionType"
                          value="delete"
                          checked={this.state.fileDocCopy.actionType === "delete"}
                          onChange={this.handleActionChange}
                        />
                        <label className="form-check-label" htmlFor="actionDelete">
                          Delete Copy
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-row mb-3">
                    <div className="col-md-6">
                      <label>
                        {this.state.fileDocCopy.actionType === "copy"
                          ? "Copy From"
                          : "Delete From"}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className={
                          isEmpty(this.state.fileDocCopy.copyFrom_file_id)
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name="copyFrom_file_id"
                        placeholder="File No."
                        value={this.state.fileDocCopy.copyFrom_file_id}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          this.setState((prevState: any) => ({
                            ...prevState,
                            fileDocCopy: {
                              ...prevState.fileDocCopy,
                              [name]: value,
                            },
                            reassignValidMessage: "",
                            showValid: false,
                          }));
                        }}
                        onBlur={() => {
                          this.getFiles(
                            this.state.fileDocCopy.copyFrom_file_id,
                            "fileDocCopy"
                          );
                        }}
                        required
                      />
                      {isEmpty(this.state?.fileDocCopy?.copyFrom_file_id) && (
                        <div className="invalid-feedback d-block">*Required Field</div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label>
                        {this.state.fileDocCopy.actionType === "copy"
                          ? "Copy To"
                          : "Delete To"}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className={
                          isEmpty(this.state.fileDocCopy.copyTo_file_id)
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name="copyTo_file_id"
                        placeholder="File No."
                        value={this.state.fileDocCopy.copyTo_file_id}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          this.setState((prevState: any) => ({
                            ...prevState,
                            fileDocCopy: {
                              ...prevState.fileDocCopy,
                              [name]: value,
                            },
                            reassignValidMessage: "",
                            showValid: false,
                          }));
                        }}
                        required
                      />
                      {isEmpty(this.state?.fileDocCopy?.copyTo_file_id) && (
                        <div className="invalid-feedback d-block">*Required Field</div>
                      )}
                    </div>
                  </div>


                  {/* File Info */}
                  {!isEmpty(this.state?.fileData?.file_status) && (
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <p>
                          <strong>File Status :</strong>{" "}
                          {getFileStatus(this.state?.fileData?.file_status)}
                        </p>
                        <p>
                          <strong>Bank Name :</strong>{" "}
                          {this.state.fileData?.bank_name ?? "-"}
                        </p>
                        <p>
                          <strong>Bank Branch Name :</strong>{" "}
                          {this.state.fileData?.bank_branch_name ?? "-"}
                        </p>
                        <p>
                          <strong>LH Branch Name :</strong>{" "}
                          {this.state.fileData?.lh_branch_name ?? "-"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Property Owner :</strong>{" "}
                          {this.state.fileData?.property_ownername ?? "-"}
                        </p>
                        <p>
                          <strong>Borrower Name :</strong>{" "}
                          {this.state.fileData?.borrower_name ?? "-"}
                        </p>
                        <p>
                          <strong>PO :</strong>{" "}
                          {this.state.fileData?.assigned_to ?? "-"}
                        </p>
                        <p>
                          <strong>VO :</strong>{" "}
                          {this.state.fileData?.verified_by ?? "-"}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Deed Info */}
                  {this.state?.deedinfo?.deedinfo &&
                    this.state.deedinfo.deedinfo.length > 0 && (
                      <div className="mt-3">
                        <TitleDeedInfo
                          path={""}
                          type_loan={this.state.deedinfo.type_loan}
                          appid={this.state.deedinfo.appid}
                          borrowername={this.state.deedinfo.borrowername}
                          bank_name={this.state.deedinfo.bank_name}
                          login_time={this.state.deedinfo.login_time}
                          loan_amount={this.state.deedinfo.loan_amount}
                          contact_number={this.state.deedinfo.contact_number}
                          coApplicant={this.state.deedinfo.coApplicant}
                          deedinfo={this.state.deedinfo.deedinfo}
                        />
                      </div>
                    )}
                </form>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({
                      isLoading: false,
                      fileData: [],
                      deedinfo: { deedinfo: [], loan_amount: '', contact_number: '', type_loan: '', appid: '', borrowername: '' },
                      fileDocCopy: { copyFrom_file_id: "", copyTo_file_id: "", actionType: "copy" },
                    });
                  }}
                >
                  Close
                </button>
                {/* Footer Action Button */}
                <button
                  type="button"
                  className={`btn ${this.state.fileDocCopy.actionType === "delete" ? "btn-danger" : "btn-primary"}`}
                  onClick={() => this.handleFileDocAction(this.state.fileDocCopy.actionType as "copy" | "delete")}
                  disabled={this.state.isLoading ||
                    this.state.fileDocCopy.copyFrom_file_id === this.state.fileDocCopy.copyTo_file_id ||
                    isEmpty(this.state.fileDocCopy.copyFrom_file_id) ||
                    isEmpty(this.state.fileDocCopy.copyTo_file_id) || isEmpty(this.state?.fileData)
                  }
                >
                  {this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : this.state.fileDocCopy.actionType === "delete" ? "Delete Copy" : "Copy"}
                </button>

              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          id="file-recover"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" style={{ maxWidth: "800px" }} role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-center">File Recover</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body express-modal-body">
                <div
                  className="row"
                // style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="col-md-10">
                    <label style={{ marginTop: "2%" }}>File Number<span style={{ color: "red" }}>*</span></label>
                    <div className="form-group document-content">
                      <input
                        className={this.state.recoverError && isEmpty(this.state.recover.file_id) ? 'form-control is-invalid' : 'form-control'}
                        name="file_id"
                        // className="form-control document-form"
                        placeholder="File No."
                        value={this.state.recover.file_id}
                        onChange={this.handlerecoverchange}
                        onBlur={() => this.getFiles(this.state.recover.file_id, 'recover')}
                        required
                      />
                    </div>
                    {this.state.recoverError && isEmpty(this.state.recover.file_id) && (
                      <div className="invalid-feedback" style={{ display: "block" }}>*Required Field</div>
                    )}
                    {this.state.showValid && (
                      <div className="invalid-feedback" style={{ display: "block", fontSize: "14px", marginBottom: "10px" }}>{this.state.reassignValidMessage}</div>
                    )}
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ marginTop: "44%", marginRight: "5%" }}
                      onClick={this.findrecover}
                    // disabled={this.state.showValid || this.state.recoverError}
                    >
                      Find
                    </button>

                  </div>
                </div>
                <div style={{ marginTop: "5%", float: "right", display: "flex", alignItems: "center" }}>


                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginTop: "5%", marginRight: "8%", float: "right" }}
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginTop: "5%", float: "right" }}
                    onClick={this.filerecover}
                    disabled={this.state.isRecoverLoading || (((this.state.showValid || this.state.recoverError) && this.state.reassignValidMessage != "File Exist") ? false : true)}
                  >
                    {this.state.isRecoverLoading ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : "Recover"}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div
          className="modal"
          id="mail-bank"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title">Auto Assign Enable & Disable</h5> */}
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                className="modal-body d-flex"
                style={{ justifyContent: "center" }}
              >
                <h5 className="modal-title">Deviation Mail to Bank Enable & Disable</h5>

                <label className="switch" style={{ marginLeft: "10%" }}>
                  <input
                    type="checkbox"
                    checked={this.state.mailtobank}
                    onChange={(e) => this.mailToBankUpdate(e)}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div style={{ padding: "2% 5%", width: "100%", borderTop: "1px solid #e5dddd" }}>
                <div className="row">
                  <div className="col-md-10" style={{ color: 'black' }}>
                    <p>Note:</p>
                    <ul>
                      <li>If Mail to bank is enable, mail send to bank by process officer when raise query.</li>
                      <li>If Mail to bank is disable, mail not send to bank when process officer raise query.</li>
                    </ul>
                  </div>
                  <div className="col-md-2" style={{ margin: "auto" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Header;
